export default __webpack_public_path__ + "static/media/zap.c5d5b27d.svg";